import { useCallback, useContext, useMemo } from "react";

import SessionContext from "app/contexts/SessionContext";
import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useSelectorProjects = () => {
    const { getDataAsync } = useApi();
    const session = useContext(SessionContext);

    const getSelectorProjectsApiCall = useCallback(async () => {
        const response = await getDataAsync("selectorProjects", {
            urlParams: [
                { name: "$userId", value: session.id },
                { name: "$isAdmin", value: session.isLegacyAdminUser },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, session.id, session.isLegacyAdminUser]);

    const selectorProjects = useQuery(
        "selectorProjectsList",
        getSelectorProjectsApiCall
    );

    return useMemo(() => {
        return {
            selectorProjects,
        };
    }, [selectorProjects]);
};

export default useSelectorProjects;
